export default "__VITE_ASSET__D4G3bAen__"